import React from 'react';
import './BubbleShell.css';

interface BubbleShellProps {
  /**
   * Основной контент: reply-цитата, forwarded-шапка, изображения, текст.
   * Для textBubble без footer последний текстовый элемент оборачивается
   * в MessageTextWithMeta (float-trick для reserved area меты).
   */
  content: React.ReactNode;
  /**
   * Footer-элементы (like strip и т.п.).
   * Когда передан — мета рендерится в footer-строке справа от контента.
   */
  footer?: React.ReactNode;
  /**
   * Элемент меты (время + галочки).
   * Передан — мета строкой под контентом справа (с footer или без: карточка проекта без текста).
   * В случае textBubble без footer — мета встроена в последний текстовый элемент
   * через MessageTextWithMeta (float right).
   */
  meta?: React.ReactNode;
  className?: string;
  /**
   * Фиксированная ширина контейнера (px). Если задана — текст внутри не сможет
   * расширить бабл шире этой ширины. Используется когда в textBubble есть
   * изображение, чтобы ширина бабла определялась изображением, а не текстом.
   */
  slotWidth?: number | null;
}

/**
 * Dumb-shell для textBubble-режима.
 * Не используется для imageOnlyBubble / attachmentOnlyBubble —
 * в тех режимах мета размещается родителем внутри media/attachment-хоста.
 */
export function BubbleShell({ content, footer, meta, className, slotWidth }: BubbleShellProps): React.ReactNode {
  const cls = ['bubbleShell', className].filter(Boolean).join(' ');
  const style: React.CSSProperties | undefined =
    slotWidth != null && slotWidth > 0 ? { width: `${slotWidth}px`, maxWidth: '100%' } : undefined;

  if (footer || meta != null) {
    return (
      <div className={cls} style={style}>
        {content}
        <div className="bubbleShell__footerRow">
          <div className="bubbleShell__footerItems">{footer}</div>
          {meta != null ? <div className="bubbleShell__footerMeta">{meta}</div> : null}
        </div>
      </div>
    );
  }

  return <div className={cls} style={style}>{content}</div>;
}
